import {
  ReceiptItem,
  ReceiptItemProps,
} from 'typescript/apps/checkout_v3/components/order_summary/components/receipt_item';
import { useTranslation } from 'react-i18next';

type TotalReceiptItemProps = {
  includesShippingAndTax?: boolean;
  includesProratedSoftware?: boolean;
  includedFeePctPerTransaction?: number;
} & ReceiptItemProps;

export const TotalReceiptItem = ({
  label,
  cost,
  currency,
  includesShippingAndTax = false,
  includesProratedSoftware = false,
  includedFeePctPerTransaction,
}: TotalReceiptItemProps) => {
  const { t } = useTranslation();

  let subtextKey = '';

  if (
    includesShippingAndTax &&
    includesProratedSoftware &&
    includedFeePctPerTransaction
  ) {
    subtextKey =
      'checkout.receipt.label.v3.totalSubtext.totalWithShippingTaxAndProratedSoftwareFee';
  } else if (includesShippingAndTax && includesProratedSoftware) {
    subtextKey =
      'checkout.receipt.label.v3.totalSubtext.totalWithShippingTaxAndProratedSoftware';
  } else if (includesShippingAndTax && includedFeePctPerTransaction) {
    subtextKey =
      'checkout.receipt.label.v3.totalSubtext.totalWithShippingTaxAndFee';
  } else if (includesProratedSoftware && includedFeePctPerTransaction) {
    subtextKey =
      'checkout.receipt.label.v3.totalSubtext.totalWithProratedSoftwareAndFee';
  } else if (includesShippingAndTax) {
    subtextKey = 'checkout.receipt.label.v3.totalSubtext.totalWithShippingTax';
  } else if (includesProratedSoftware) {
    subtextKey =
      'checkout.receipt.label.v3.totalSubtext.totalWithProratedSoftware';
  } else if (includedFeePctPerTransaction) {
    subtextKey = 'checkout.receipt.label.v3.totalSubtext.totalWithFee';
  }

  return (
    <ReceiptItem
      label={label}
      cost={cost}
      currency={currency}
      subtext={subtextKey ? t(subtextKey) : null}
      emphasize={true}
    />
  );
};
